@if (branch.length > 0 || version.length > 0) {
	<div class="cp-build-version-container" tabindex="0"
		(click)="dismiss($event)" (keypress)="keyPressHandler($event, dismiss($event))">
		Branch: {{branch}}<br />
		Version: {{version}}
	</div>
}